




























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import SuporteProcedimentosStore from '@/components/Suporte/Store/SuporteProcedimentosStore'
import { DataTablePagination } from '@/types/_'
import { useHospitais } from '@/composables'

@Component
export default class ViewSuporteProcedimentos extends Vue {
  loadProcedimento: string = ''
  loadProcedimentos: boolean = false
  loadAdicionarProcedimento: boolean = false
  loadApagarProcedimento: string = ''

  get getSuporteProcedimentosStore() {
    return getModule(SuporteProcedimentosStore, this.$store)
  }

  get paginationProcedimento() { return this.getSuporteProcedimentosStore.paginationProcedimento }

  get loadingProcedimento() { return this.loadProcedimento }
  set loadingProcedimento(value: string) { this.loadProcedimento = value }
  get loadingProcedimentos() { return this.loadProcedimentos }
  set loadingProcedimentos(value: boolean) { this.loadProcedimentos = value }
  get loadingAdicionarProcedimento() { return this.loadAdicionarProcedimento }
  set loadingAdicionarProcedimento(value: boolean) { this.loadAdicionarProcedimento = value }
  get loadingApagarProcedimento() { return this.loadApagarProcedimento }
  set loadingApagarProcedimento(value: string) { this.loadApagarProcedimento = value }

  get hospitalId() { return this.getSuporteProcedimentosStore.hospitalId }
  set hospitalId(value: string) { this.getSuporteProcedimentosStore.setHospitalId(value) }
  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get procedimentosHeaders() {
    return [
      { text: 'Código', value: 'codigo', sortable: false },
      { text: 'HisId', value: 'hisId', sortable: false },
      { text: 'Descrição', value: 'descricao', sortable: false },
      { text: 'Porte', value: 'porte', sortable: false },
      { text: 'Quantidades auxiliares', value: 'quantidadeAuxiliares', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Lateralidade', value: 'temLateralidade', sortable: false },
      { text: 'Tipo', value: 'tipo', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get procedimentos() { return this.getSuporteProcedimentosStore.procedimentos }
  get searchProcedimento() { return this.getSuporteProcedimentosStore.searchProcedimento }
  set searchProcedimento(value: string) { this.getSuporteProcedimentosStore.setSearchProcedimento(value) }

  @Watch('searchProcedimento')
  async onChangeSearchProcedimento(value: any) {
    this.procedimentoPagedDebounce({ ...this.paginationProcedimento })
  }

  async hospitalChange(id: any) {
    this.getSuporteProcedimentosStore.clearSearchProcedimento()
    this.getSuporteProcedimentosStore.setHospitalId(id)

    const params: any = { hospitalId: id, ...this.getSuporteProcedimentosStore.paginationDefault }

    this.loadingProcedimentos = true
    await this.getSuporteProcedimentosStore.getProcedimentoPagedSearch(params)
    this.loadingProcedimentos = false
  }

  procedimentoPagedDebounce = _.debounce(param => this.getSuporteProcedimentosStore.getProcedimentoPagedSearch(param), 700)

  async updatePaginationProcedimentos(pagination: DataTablePagination) {
    if (['', null, undefined].includes(this.hospitalId)) return
    this.loadingProcedimentos = true
    this.procedimentoPagedDebounce(pagination)
    this.loadingProcedimentos = false
  }

  async adicionarProcedimento() {
    this.loadingAdicionarProcedimento = true
    this.getSuporteProcedimentosStore.setMode({ modal: 'procedimento', mode: 'CREATE' })
    this.getSuporteProcedimentosStore.clearProcedimento()
    await this.getSuporteProcedimentosStore.getAllTecnicas()
    this.getSuporteProcedimentosStore.setModal({ name: 'procedimento', value: true })
    this.loadingAdicionarProcedimento = false
  }

  async editarProcedimento(item: any) {
    this.loadingProcedimento = item.id
    const request = await this.getSuporteProcedimentosStore.getTecnicasDoProcedimentoByProcedimentoId(item.id)
    if (request.success) item.tecnicasDoProcedimento = request.data.tecnicasDoProcedimento || []
    await this.getSuporteProcedimentosStore.getAllTecnicas()
    this.getSuporteProcedimentosStore.setMode({ modal: 'procedimento', mode: 'EDIT' })
    this.getSuporteProcedimentosStore.setProcedimento({ ...item })
    this.getSuporteProcedimentosStore.setModal({ name: 'procedimento', value: true })
    this.loadingProcedimento = ''
  }

  async apagarProcedimento(item: any) {
    this.loadingApagarProcedimento = item.id
    this.getSuporteProcedimentosStore.deleteProcedimento(item)
    this.loadingApagarProcedimento = ''
  }

  beforeDestroy() {
    this.getSuporteProcedimentosStore.clearProcedimentos()
    this.getSuporteProcedimentosStore.clearHospitalId()
  }
}
